// import React from 'react';
import { Form, Card, Space } from 'antd';
import FormItem from 'common/FormItem';
import CustomButton from 'common/CustomButton';
import { SafetyCertificateOutlined, AppstoreFilled } from '@ant-design/icons';
import styles from './index.module.less';
import trackex from '../../images/trackex.png';
import { useDispatch } from 'react-redux';
import { useMsal, useIsAuthenticated } from '@azure/msal-react';
import { login } from '../../redux/slice';
import LocalStorage from '../../../../utilities/localStorage.js';
import { history } from '@/app/history';

const LoginPage = ({ loading }) => {
  const [form] = Form.useForm();
  const { instance } = useMsal();
  const dispatch = useDispatch();
  const isAuthenticated = useIsAuthenticated();

  const handleMicrosoftLogin = () => {
    instance
      .loginPopup({
        scopes: ['User.Read'],
        // redirectUri: 'http://localhost:3000/login'
        // redirectUri: 'https://app.trackex.co/session.html'
        redirectUri: 'https://dev.trackex.co/session.html'
      })
      .then((result) => {
        return dispatch(login({ token: result.accessToken }));
      })

      .then((result) => {
        if (result.payload.success) {
          LocalStorage.setItem('trackex_user', JSON.stringify(result.payload));
          // const user = result.payload;
          history.push('/dashboard');
        } else {
          console.log('result:', result);
        }
      })
      .catch(() => {
        if (isAuthenticated) {
          instance.logoutRedirect({
            account: LocalStorage.homeAccountId,
            postLogoutRedirectUri: '/',
            mainWindowRedirectUri: '/'
          });
        }
      });
  };

  return (
    <div className={styles.container}>
      <Card className={styles.card}>
        <div className={styles.cardDiv}>
          <img
            src={trackex} // Update path to your actual logo
            alt="Trackex Logo"
            className={styles.logo}
          />
        </div>
        <Space direction="vertical">
          <h2 className={styles.title}>Welcome back</h2>
          <h6 className={styles.tagline}>Operational clarity. Daily</h6>
        </Space>

        <Form form={form} layout="vertical">
          <FormItem>
            <CustomButton
              type="primary"
              htmlType="submit"
              loading={loading}
              onClick={handleMicrosoftLogin}
              className={styles.microsoftButton}
              icon={<AppstoreFilled />}
            >
              Sign in with email
            </CustomButton>
          </FormItem>
        </Form>

        <Space>
          <span className={styles.shieldIcon}>
            <SafetyCertificateOutlined />
          </span>
          <span className={styles.securityText}>
            Secure authentication powered by Microsoft AD
          </span>
        </Space>
      </Card>
    </div>
  );
};

export default LoginPage;
